import { render, staticRenderFns } from "./login-card.vue?vue&type=template&id=2387432a&scoped=true"
import script from "./login-card.vue?vue&type=script&lang=js"
export * from "./login-card.vue?vue&type=script&lang=js"
import style0 from "./login-card.vue?vue&type=style&index=0&id=2387432a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2387432a",
  null
  
)

export default component.exports